import { Box, CircularProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { detailYunoAction } from '_models/redux/detail-transactions-yuno/action';
import { cleanDetailYunoAction } from '_models/redux/detail-transactions-yuno/clean-action';
import { yunoAction } from '_models/redux/list-transactions-yuno/action';
import { cleanYunoAction } from '_models/redux/list-transactions-yuno/clean-action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import { useState } from 'react';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTable from 'widgets/datagrid/DataTable';
import FiltroYuno from './components/FiltroYuno';
import FraudConfirmationDialog from './components/FraudConfirmationDialog';
import TransactionDetailsYuno from './components/TransactionDetailsYuno';
import { useTransactionsYunoHook } from './hooks/useTransactionsYunoHook';
const PageTransactionYuno = ({
  yunoAction,
  cleanYunoAction,
  listYuno,
  detailYunoAction,
  cleanDetailYunoAction,
  detailTransactionsYuno,

  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    isDialogOpen, //aqui
    dialogTitleMessage,
    dialogMessage,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleConfirm,
    loadingFraudAndChargeback,
    isError,
    handleCloseFraudChargeback, //aqui
    setOpenActionFraud,
    handleOpenPopUp,
    setIdReverso,
    setActiveAction,
    setShouldReturnData,
    activeAction,
    shouldReturnData,
  } = useTransactionsYunoHook({
    yunoAction,
    cleanYunoAction,
    listYuno,
    detailYunoAction,
    cleanDetailYunoAction,
    detailTransactionsYuno,

    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    transactionId,
    onClose,
  });
  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };
  return (
    <Box>
      <Grid>
        <h4>Transacciones de Yuno</h4>
      </Grid>
      <Box sx={{ mb: 4 }}>
        <FiltroYuno
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Box>
      {loading && <CircularProgress />}
      {mappedRows?.length > 0 ? (
        <Grid paddingLeft={0}>
          <Box>
            <DataTable
              rows={mappedRows}
              columns={Columns}
              onRowClick={handleRowClick}
              page={page}
              pageSize={size}
              rowCount={pagination?.total_rows ?? 0}
              onPageChange={pagination?.handleChangePage}
              handleChangePageSize={pagination?.handleChangePageSize}
              loading={loading}
            />
          </Box>
        </Grid>
      ) : (
        !loading &&
        mappedRows.length === 0 &&
        hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
      )}
      <TransactionDetailsYuno
        open={isDialogOpenDetails}
        onClose={handleClose}
        loading={loading}
        detailTransactionsYuno={detailTransactionsYuno}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
        setIdReverso={setIdReverso}
        setActiveAction={setActiveAction}
        setShouldReturnData={setShouldReturnData}
        activeAction={activeAction}
        shouldReturnData={shouldReturnData}
      />
      <CustomDialog
        title={dialogTitleMessage}
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
      <FraudConfirmationDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        handleConfirm={handleConfirm}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
      />
    </Box>
  );
};
const mapStateToProps = (state) => ({
  listYuno: state?.listYuno,
  detailTransactionsYuno: state?.detailTransactionsYuno,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});
const mapDispatchToProps = {
  yunoAction,
  cleanYunoAction,
  detailYunoAction,
  cleanDetailYunoAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};
export default connect(mapStateToProps, mapDispatchToProps)(PageTransactionYuno);
